module.exports = __webpack_public_path__ + "media/controllers/city_icon_hover-84f8bee549e7a01d0cc6cb954269d936.svg";